// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prod-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  min-width: 0;
}

.prod-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.prod-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.prod-form__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.prod-form__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  line-height: 1.3;
}

.prod-form__req {
  color: #F43F5E;
}

.prod-form__optional,
.prod-form__aside {
  font-size: 11px;
  font-weight: 400;
  color: #94A3B8;
}

.prod-form__barcode {
  position: relative;
}

.prod-form__barcode-icon {
  position: absolute;
  top: 12px;
  inset-inline-start: 12px;
  color: #94A3B8;
  pointer-events: none;
  z-index: 1;
}

.prod-form .ant-form-item {
  margin-bottom: 0 !important;
}

.prod-form .ant-form-item-label,
.prod-form .ant-form-item-feedback-icon {
  display: none !important;
}

.prod-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.prod-form .ant-select,
.prod-form .ant-input-number,
.prod-form .ant-input-number-affix-wrapper,
.prod-form .ant-input-number-group-wrapper {
  width: 100% !important;
}

.prod-form .ant-select-single .ant-select-selector,
.prod-form .ant-input-number-affix-wrapper,
.prod-form .ant-input-affix-wrapper,
.prod-form .ant-form-item-control-input-content > input.ant-input {
  box-sizing: border-box !important;
  height: 40px !important;
  min-height: 40px !important;
  border: 1px solid #E2E8F0 !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 12px !important;
  color: #1E293B !important;
}

.prod-form .ant-input-number-affix-wrapper {
  padding: 0 !important;
}

.prod-form .ant-input-number-affix-wrapper .ant-input-number {
  flex: 1 1 auto;
  width: 100% !important;
  height: 38px !important;
  min-height: 0 !important;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.prod-form .ant-select-single .ant-select-selector,
.prod-form .ant-form-item-control-input-content > input.ant-input,
.prod-form .ant-input-affix-wrapper {
  padding-inline: 14px !important;
}

.prod-form .ant-select-single .ant-select-selector {
  display: flex !important;
  align-items: center;
}

.prod-form .ant-select-single .ant-select-selection-item,
.prod-form .ant-select-single .ant-select-selection-placeholder {
  line-height: 38px !important;
  font-size: 12px !important;
}

.prod-form .ant-input-number-input {
  height: 38px !important;
  padding: 0 14px !important;
  font-size: 12px !important;
}

.prod-form__barcode .ant-form-item-control-input-content > input.ant-input,
.prod-form__barcode .ant-input-affix-wrapper {
  padding-inline-start: 36px !important;
}

.prod-form .ant-input-affix-wrapper input.ant-input {
  height: 100% !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.prod-form .ant-select-focused .ant-select-selector,
.prod-form .ant-input-number-affix-wrapper-focused,
.prod-form .ant-input-number-affix-wrapper:focus-within,
.prod-form .ant-input-affix-wrapper-focused,
.prod-form .ant-input-affix-wrapper:focus-within,
.prod-form .ant-form-item-control-input-content > input.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;
}

.prod-form .ant-form-item-has-error .ant-select-selector,
.prod-form .ant-form-item-has-error .ant-input-number-affix-wrapper,
.prod-form .ant-form-item-has-error .ant-input-affix-wrapper,
.prod-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input {
  border-color: #F43F5E !important;
}

.prod-form__note {
  box-sizing: border-box;
  width: 100%;
  height: 96px;
  padding: 10px 14px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  resize: none;
  font-size: 12px;
  line-height: 1.5;
  color: #1E293B;
}

.prod-form__note::placeholder,
.prod-form input::placeholder {
  color: #94A3B8;
}

.prod-form__note:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}

@media (max-width: 640px) {
  .prod-form__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/inventory/products/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;;EAIE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;;;;;EAME,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".prod-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  min-width: 0;\n}\n\n.prod-form__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.prod-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.prod-form__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.prod-form__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.prod-form__req {\n  color: #F43F5E;\n}\n\n.prod-form__optional,\n.prod-form__aside {\n  font-size: 11px;\n  font-weight: 400;\n  color: #94A3B8;\n}\n\n.prod-form__barcode {\n  position: relative;\n}\n\n.prod-form__barcode-icon {\n  position: absolute;\n  top: 12px;\n  inset-inline-start: 12px;\n  color: #94A3B8;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.prod-form .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.prod-form .ant-form-item-label,\n.prod-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.prod-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.prod-form .ant-select,\n.prod-form .ant-input-number,\n.prod-form .ant-input-number-affix-wrapper,\n.prod-form .ant-input-number-group-wrapper {\n  width: 100% !important;\n}\n\n.prod-form .ant-select-single .ant-select-selector,\n.prod-form .ant-input-number-affix-wrapper,\n.prod-form .ant-input-affix-wrapper,\n.prod-form .ant-form-item-control-input-content > input.ant-input {\n  box-sizing: border-box !important;\n  height: 40px !important;\n  min-height: 40px !important;\n  border: 1px solid #E2E8F0 !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 12px !important;\n  color: #1E293B !important;\n}\n\n.prod-form .ant-input-number-affix-wrapper {\n  padding: 0 !important;\n}\n\n.prod-form .ant-input-number-affix-wrapper .ant-input-number {\n  flex: 1 1 auto;\n  width: 100% !important;\n  height: 38px !important;\n  min-height: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.prod-form .ant-select-single .ant-select-selector,\n.prod-form .ant-form-item-control-input-content > input.ant-input,\n.prod-form .ant-input-affix-wrapper {\n  padding-inline: 14px !important;\n}\n\n.prod-form .ant-select-single .ant-select-selector {\n  display: flex !important;\n  align-items: center;\n}\n\n.prod-form .ant-select-single .ant-select-selection-item,\n.prod-form .ant-select-single .ant-select-selection-placeholder {\n  line-height: 38px !important;\n  font-size: 12px !important;\n}\n\n.prod-form .ant-input-number-input {\n  height: 38px !important;\n  padding: 0 14px !important;\n  font-size: 12px !important;\n}\n\n.prod-form__barcode .ant-form-item-control-input-content > input.ant-input,\n.prod-form__barcode .ant-input-affix-wrapper {\n  padding-inline-start: 36px !important;\n}\n\n.prod-form .ant-input-affix-wrapper input.ant-input {\n  height: 100% !important;\n  padding: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.prod-form .ant-select-focused .ant-select-selector,\n.prod-form .ant-input-number-affix-wrapper-focused,\n.prod-form .ant-input-number-affix-wrapper:focus-within,\n.prod-form .ant-input-affix-wrapper-focused,\n.prod-form .ant-input-affix-wrapper:focus-within,\n.prod-form .ant-form-item-control-input-content > input.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;\n}\n\n.prod-form .ant-form-item-has-error .ant-select-selector,\n.prod-form .ant-form-item-has-error .ant-input-number-affix-wrapper,\n.prod-form .ant-form-item-has-error .ant-input-affix-wrapper,\n.prod-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input {\n  border-color: #F43F5E !important;\n}\n\n.prod-form__note {\n  box-sizing: border-box;\n  width: 100%;\n  height: 96px;\n  padding: 10px 14px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  resize: none;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #1E293B;\n}\n\n.prod-form__note::placeholder,\n.prod-form input::placeholder {\n  color: #94A3B8;\n}\n\n.prod-form__note:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);\n}\n\n@media (max-width: 640px) {\n  .prod-form__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
